var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radial-container",staticStyle:{"width":"100%"}},[_c('svg',{attrs:{"width":_vm.size,"height":_vm.size}}),(_vm.showText)?_c('div',{staticClass:"radial-inner"},[_vm._t("default",[_c('span',{staticClass:"inner-text"},[_vm._v(_vm._s(_vm.textToShow))])])],2):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71b18a92","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Radial.vue
// module id = null
// module chunks = 